import rotating from './rotating-animation'
import basic from './basic-animation'// Basic build

export default [
  rotating,
  basic
]
